module.exports = __webpack_public_path__ + "img/goal-16.408a4033.png";